import HttpClient from "@/common/boot/HttpClient"

const listarModulos = async({ commit }, payload) => {

    commit('CARREGANDO', true);

    await HttpClient.get('/app/modulos', payload).then(response => {
            commit('LISTAR_DADOS', response.data.data);
            return response;
        })
        .finally(() => {
            commit('CARREGANDO', false);
        });
}

const excluirModulos = async({ dispatch }, payload) => {
    let qtdRows = payload.length;
    for (let i = 0; i < qtdRows; ++i) {
        await excluir(payload[i]);
    }

    dispatch('listarModulos');
}

const excluir = async(linha) => {
    const resp = await HttpClient.delete(`/app/modulos/${linha.id}`).then(response => { return response; });
    return resp;
}

const salvarModulo = async({ commit }, payload) => {

    commit('CARREGANDO', true);

    return await HttpClient.post('/app/modulos', payload).then(response => {
            commit('INSERIR_MODULO', response.data.data);
            return response;
        })
        .finally(() => {
            commit('CARREGANDO', false);
        });
}

const recuperarModulo = ({ commit, state }, payload) => {
    const modulo = state.items.filter(modulo => modulo.id === payload.id);
    if (modulo.length) {
        commit('INSERIR_MODULO_SELECIONADO', ...modulo);
        return true;
    }

    return false;
}

const atualizarModulo = async({ commit }, payload) => {
    commit('CARREGANDO', true);
    return await HttpClient.put(`/app/modulos/${payload.id}`, payload).then(response => {
            commit('ATUALIZAR_MODULO', response.data.data);
            return response;
        })
        .finally(() => {
            commit('CARREGANDO', false);
        })
}

export {
    listarModulos,
    excluirModulos,
    salvarModulo,
    recuperarModulo,
    atualizarModulo
}